import React from "react";
import { Box, Typography } from "@mui/material";
import WarningAmberOutlinedIcon from "@mui/icons-material/WarningAmberOutlined";
import ModalShell from "../CollectionsTab/ModalShell";
import { AdminSurveyRequestSummary } from "../../../api/derin";
import { collectionColors, font, subtitleSx } from "../CollectionsTab/tokens";
import { formatUtcDate } from "./format";

interface DeleteSurveyRequestDialogProps {
  open: boolean;
  request: AdminSurveyRequestSummary | null;
  organizationName: string;
  onClose: () => void;
  onConfirm: () => void;
  isSubmitting?: boolean;
}

/**
 * A soft delete on the API side, but there is no restore in the portal: once confirmed,
 * the request is gone from this tab and from the client's My Surveys.
 */
const DeleteSurveyRequestDialog: React.FC<DeleteSurveyRequestDialogProps> = ({
  open,
  request,
  organizationName,
  onClose,
  onConfirm,
  isSubmitting = false,
}) => (
  <ModalShell
    open={open}
    onClose={onClose}
    title="Delete survey request?"
    confirmLabel="Delete request"
    onConfirm={onConfirm}
    isSubmitting={isSubmitting}
    danger
  >
    {request && (
      <Box
        sx={{
          display: "flex",
          gap: "10px",
          padding: "12px",
          background: collectionColors.dangerSurface,
          borderRadius: "8px",
        }}
      >
        <WarningAmberOutlinedIcon
          sx={{ width: 18, height: 18, color: collectionColors.danger, flexShrink: 0 }}
        />
        <Box sx={{ minWidth: 0 }}>
          <Typography
            sx={{
              fontFamily: font,
              fontWeight: 500,
              fontSize: "14px",
              lineHeight: "20px",
              color: collectionColors.danger,
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {request.title}
          </Typography>
          <Typography sx={{ ...subtitleSx, fontSize: "13px", lineHeight: "18px" }}>
            Submitted by {request.submittedBy.name} on {formatUtcDate(request.submittedAt)}
          </Typography>
        </Box>
      </Box>
    )}
    <Typography sx={subtitleSx}>
      {organizationName} will no longer see this request on My Surveys. This can't be undone
      from the portal.
    </Typography>
  </ModalShell>
);

export default DeleteSurveyRequestDialog;
